import axios from 'axios';

const getAllEmployeesApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/Employee/getMyEmployees?store_id=${
      paramsFilter?.storeId || ''
    }`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getAllEmployeesApi;
